import { put, delay } from 'redux-saga/effects';

import { Creators as UiCreators } from '../ducks/ui';

export function* growl({ payload }) {
  yield delay(5000);
  yield put(UiCreators.removeGrowl(payload.message));
}
